<template>
  <vx-card title="Neukunden vs. Wiederkehrende (pro Woche)">
    <vue-apex-charts
      type="bar"
      height="300"
      :options="chartOptions"
      :series="series"
    />
  </vx-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "AnalyticsNewVsReturning",
  components: { VueApexCharts },
  computed: {
    rawData() {
      return this.$store.state.analytics.newVsReturning || [];
    },
    series() {
      return [
        {
          name: "Neukunden",
          data: this.rawData.map((w) => w.newCustomers),
        },
        {
          name: "Wiederkehrende",
          data: this.rawData.map((w) => w.returningCustomers),
        },
      ];
    },
    labels() {
      return this.rawData.map((w) => {
        const parts = w._id.split("-");
        return `${parts[2]}.${parts[1]}`;
      });
    },
    chartOptions() {
      return {
        chart: {
          stacked: true,
          toolbar: { show: false },
          foreColor: "#c2c6dc",
          background: "transparent",
        },
        theme: { mode: "dark" },
        grid: { borderColor: "rgba(255,255,255,0.06)" },
        xaxis: { categories: this.labels },
        dataLabels: { enabled: false },
        colors: ["#C41E2A", "#2ECC71"],
        fill: { opacity: 0.75 },
        plotOptions: {
          bar: { borderRadius: 3, columnWidth: "55%" },
        },
        legend: { position: "top" },
        tooltip: {
          shared: true,
          intersect: false,
        },
      };
    },
  },
};
</script>
